module.exports = __webpack_public_path__ + "media/images/diy/bg-shape-8-71809e8f6d0c94ef75ffbb9fbe683f91.svg";